import {isNil} from 'ramda';

import {buildAssistantEntityContext} from '@dms/ai-assistant';
import type {RentalOrderResponseBody} from '@dms/api/rental';

export const getRentalOrderAssistantEntities = (
  rentalOrderId: string | undefined,
  rentalOrder:
    | Pick<RentalOrderResponseBody, 'rentalOrderId' | 'number' | 'rentalVehicleId' | 'customerId'>
    | undefined,
  labels: {vehicle?: string; customer?: string} = {}
) => {
  if (isNil(rentalOrder) || rentalOrder.rentalOrderId !== rentalOrderId) {
    return undefined;
  }

  return buildAssistantEntityContext({
    rentalOrder: {id: rentalOrder.rentalOrderId, label: rentalOrder.number},
    vehicle: isNil(rentalOrder.rentalVehicleId)
      ? undefined
      : {id: rentalOrder.rentalVehicleId, label: labels.vehicle},
    customer: isNil(rentalOrder.customerId)
      ? undefined
      : {id: rentalOrder.customerId, label: labels.customer},
  });
};
